import { useState, useEffect, useCallback } from 'react';
import { invitationsApi } from '../api/invitationsApi';

export function useInvitations() {
  const [invitations, setInvitations] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subUsers, setSubUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [invs, cats, subs] = await Promise.all([
        invitationsApi.fetchInvitations(),
        invitationsApi.fetchCategories(),
        invitationsApi.fetchSubUsers(),
      ]);
      setInvitations(invs);
      setCategories(cats);
      setSubUsers(subs);
    } catch (err) {
      setError(err.response?.data?.detail || 'Veri yüklenemedi.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const sendInvitation = async (payload) => {
    await invitationsApi.sendInvitation(payload);
    await refresh();
  };

  const resendInvitation = async (id) => {
    await invitationsApi.resendInvitation(id);
    await refresh();
  };

  const cancelInvitation = async (id) => {
    await invitationsApi.cancelInvitation(id);
    await refresh();
  };

  const toggleSubUserStatus = async (id) => {
    await invitationsApi.toggleSubUserStatus(id);
    await refresh();
  };

  // Phase 86AZ.16 — Customer-admin removes a sub-user. Backend hard-deletes
  // the user + cancels the originating invitation + emails a heads-up.
  const deleteSubUser = async (id) => {
    await invitationsApi.deleteSubUser(id);
    await refresh();
  };

  return {
    invitations,
    categories,
    subUsers,
    loading,
    error,
    refresh,
    sendInvitation,
    resendInvitation,
    cancelInvitation,
    toggleSubUserStatus,
    deleteSubUser,
  };
}
